export default __webpack_public_path__ + "static/media/arrow-right.89daa215.svg";